import SubSectionWrapper from '@/components/layouts/AppShell/PatientProfileDrawer/SubSectionWrapper/SubSectionWrapper';
import classes from './PersonalDetails.module.css';
import useWhoAmI from '@/hooks/useWhoAmI';
import { presentUsPhoneNumber } from '@/lib/formatters/telephone';
import ProfileFieldListItem from './ProfileFieldListItem/ProfileFieldListItem';
import { Tooltip } from '@mantine/core';
import Icon from '@/components/Icon';
import useSupportInfo from '@/hooks/useSupportInfo';

interface PersonalDetailsProps {
  onGoBack: () => void;
}

const PersonalDetails = ({ onGoBack }: PersonalDetailsProps) => {
  const { user } = useWhoAmI();
  const { supportEmail } = useSupportInfo();

  const {
    firstName,
    lastName,
    addresses,
    phoneNumbers,
    emailAddresses,
    preferredName,
    pronouns,
    genderIdentity,
  } = user || {};

  return (
    <SubSectionWrapper title="Personal Details" onGoBack={onGoBack}>
      <ul className={classes.unorderedList}>
        <ProfileFieldListItem label="First name" value={firstName} />
        <ProfileFieldListItem label="Last name" value={lastName} />
        {addresses?.map(({ state, postalCode, city }, index) => (
          <ProfileFieldListItem
            key={`${index}-${city}-${state}-${postalCode}`}
            label="Street address"
            value={[city, state, postalCode].filter(Boolean).join(', ')}
            valueName="addresses"
            index={index}
          />
        ))}
        {phoneNumbers?.map(({ value }, index) => (
          <ProfileFieldListItem
            key={`${index}-${value}`}
            label="Phone number"
            value={presentUsPhoneNumber(value)}
            index={index}
            actionIcon={
              <Tooltip
                label={`To edit your phone number or email address, please email our Support Team at ${supportEmail}.`}
                multiline
                style={{ width: '300px' }}
                events={{ hover: true, focus: false, touch: true }}>
                <span>
                  <Icon name="feather/info" size="sm" />
                </span>
              </Tooltip>
            }
          />
        ))}
        {emailAddresses?.map(({ value }, index) => (
          <ProfileFieldListItem
            key={`${index}-${value}`}
            label="Email address"
            value={value}
            actionIcon={
              <Tooltip
                label={`To edit your phone number or email address, please email our Support Team at ${supportEmail}.`}
                multiline
                style={{ width: '300px' }}
                events={{ hover: true, focus: false, touch: true }}>
                <span>
                  <Icon name="feather/info" size="sm" />
                </span>
              </Tooltip>
            }
          />
        ))}
        <ProfileFieldListItem
          label="Nickname"
          value={preferredName}
          valueName="preferredName"
        />
        <ProfileFieldListItem
          label="Preferred pronouns"
          value={pronouns?.text}
          valueName="pronouns"
        />
        <ProfileFieldListItem
          label="Gender"
          value={genderIdentity?.text}
          valueName="genderIdentity"
        />
      </ul>
    </SubSectionWrapper>
  );
};

export default PersonalDetails;
